import React from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";

import CrmShell from "../components/CrmShell";
import { CrmPageHeader, CrmPanel, MetricCard, crmUi } from "../components/CrmUi";
import { activities } from "../demoData";

const CrmActivitiesPage = () => {
  const open = activities.filter(x => x.status !== "Klar");
  const done = activities.filter(x => x.status === "Klar");

  return (
    <CrmShell>
      <CrmPageHeader
        title="Aktiviteter"
        subtitle="Samtal, möten, e-post, uppgifter och andra CRM-händelser."
        actions={[
          <Button key="new" size="small" variant="contained" startIcon={<AddOutlinedIcon />} sx={{ textTransform: "none" }}>
            Ny aktivitet
          </Button>,
        ]}
      />

      <Grid container spacing={1.15}>
        <Grid item xs={12} sm={6}>
          <MetricCard label="Öppna aktiviteter" value={open.length} icon={<ScheduleOutlinedIcon />} tone="warning" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MetricCard label="Slutförda senaste perioden" value={done.length} icon={<CheckCircleOutlineRoundedIcon />} tone="success" />
        </Grid>

        <Grid item xs={12}>
          <CrmPanel sx={{ p: 1.2 }}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={0.7}>
              <TextField size="small" placeholder="Sök aktiviteter..." sx={{ flex: 1 }} />
              {["Typ", "Status", "Ansvarig", "Organisation"].map(label => (
                <TextField key={label} size="small" select defaultValue="" sx={{ minWidth: 130 }}>
                  <MenuItem value="">{label}</MenuItem>
                </TextField>
              ))}
            </Stack>
          </CrmPanel>
        </Grid>

        <Grid item xs={12} lg={5}>
          <CrmPanel sx={{ p: 1.4, height: "100%" }}>
            <Typography sx={{ color: crmUi.text, fontSize: 13.5, fontWeight: 550 }}>Kommande</Typography>
            <List dense disablePadding sx={{ mt: 0.6 }}>
              {open.map(item => (
                <React.Fragment key={item.id}>
                  <ListItem disableGutters alignItems="flex-start" sx={{ py: 0.7 }}>
                    <ListItemText
                      primary={item.title}
                      secondary={`${item.organization} · ${item.contact}`}
                      primaryTypographyProps={{ fontSize: 10.8, color: crmUi.text }}
                      secondaryTypographyProps={{ fontSize: 9.5, color: crmUi.muted }}
                    />
                    <Stack spacing={0.35} alignItems="flex-end">
                      <Typography sx={{ fontSize: 9.6, color: crmUi.muted }}>{item.when}</Typography>
                      <Chip label={item.type} size="small" sx={{ height: 19, fontSize: 9 }} />
                    </Stack>
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          </CrmPanel>
        </Grid>

        <Grid item xs={12} lg={7}>
          <CrmPanel sx={{ p: 1.4, height: "100%" }}>
            <Typography sx={{ color: crmUi.text, fontSize: 13.5, fontWeight: 550 }}>Historik</Typography>
            <Box sx={{ mt: 0.75 }}>
              {done.map((item, index) => (
                <Stack key={item.id} direction="row" spacing={1} alignItems="flex-start" sx={{ position: "relative", pb: 1.25 }}>
                  <Box
                    sx={{
                      width: 9,
                      height: 9,
                      mt: 0.55,
                      borderRadius: "50%",
                      bgcolor: index === 0 ? "primary.main" : "#c9ced6",
                      flexShrink: 0,
                      zIndex: 1,
                    }}
                  />
                  {index < done.length - 1 && (
                    <Box sx={{ position: "absolute", left: 4, top: 14, bottom: 0, width: 1, bgcolor: "#e1e5ea" }} />
                  )}
                  <Box sx={{ flex: 1 }}>
                    <Stack direction="row" justifyContent="space-between" spacing={1}>
                      <Typography sx={{ color: crmUi.text, fontSize: 10.8 }}>{item.title}</Typography>
                      <Typography sx={{ color: crmUi.muted, fontSize: 9.5, flexShrink: 0 }}>{item.when}</Typography>
                    </Stack>
                    <Typography sx={{ mt: 0.2, color: crmUi.muted, fontSize: 9.5 }}>
                      {item.organization} · {item.type}
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </Box>
          </CrmPanel>
        </Grid>
      </Grid>
    </CrmShell>
  );
};

export default CrmActivitiesPage;
